import React from "react";

var CryptoJS = require("crypto-js");

export const encryptDecrypt = {
    /**
     * decrypt plain encrypted string data
    */
    decryptStringHelper,
    /**
     * decrypt json object encrypted data to json object @return {JSON Object}
    */
    decryptObjectHelper,
    /**
        * encrypt plain string data @return {plainText encrypted data}
       */
    encryptStringHelper,
    /**
    * encrypt json object data @return {plainText encrypted data}
    */
    encryptObjectHelper,
    encpwd,
    decpwd,
    EncryptText,
    DecryptText,
    encryptOtp,
    setAbhaPublicKey
      /**
    * encrypt json object data @return {plainText encrypted data}
    */

}


async function decryptStringHelper(cipherText) {
    let decryptedData = ''
    // if (cipherText !== null && cipherText !== '') {
    //     let bytes = CryptoJS.AES.decrypt(cipherText, process.env.REACT_APP_encryp_Key);
    //     decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    // }
    if (cipherText !== '') {
        const key2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encryp_Key);
        const iv2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encrypt_Iv);
        const dec = CryptoJS.AES.decrypt(cipherText, key2, {
            iv: iv2,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            keySize: 256 / 32
        });
        decryptedData = dec.toString(CryptoJS.enc.Utf8);
    }
    return decryptedData;

}

function decryptObjectHelper(cipherText) {
    
    let decryptedData = {};
    // if (cipherText !== null && cipherText !== '') {
    //     let bytes = CryptoJS.AES.decrypt(cipherText, process.env.REACT_APP_encryp_Key);
    //     decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    // }
    if (cipherText !== '') {
        const key2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encryp_Key);
        const iv2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encrypt_Iv);
        const dec = CryptoJS.AES.decrypt(cipherText, key2, {
            iv: iv2,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            keySize: 256 / 32
        });
        return JSON.parse(dec.toString(CryptoJS.enc.Utf8));
        
    }
    return decryptedData;
}

function encryptStringHelper(cipherText) {
    let encryptedData = ''
    const key2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encryp_Key);
    const iv2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encrypt_Iv);
    if (cipherText !== null && cipherText !== '') {
        encryptedData = CryptoJS.AES.encrypt(cipherText, key2,
            {
                iv: iv2,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
                keySize: 256 / 32
            }
        ).toString();
    }
    return encryptedData;

}

function encryptObjectHelper(jsonData) {
    let encryptedObject = ''
    const key2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encryp_Key);
    const iv2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encrypt_Iv);
    if (jsonData !== null && jsonData !== '' && typeof jsonData === 'object') {
        let jsonString = JSON.stringify(jsonData);
        encryptedObject = CryptoJS.AES.encrypt(jsonString, key2,
            {
                iv: iv2,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
                keySize: 256 / 32
            }
        ).toString();
    }
    if(encryptedObject === '')
        {
            encryptedObject = jsonData;
        }
    return encryptedObject;
}

function encpwd(cipherText) {
    let encryptedString = ''
    if (cipherText !== '') {
        /*
        Length of secret key should be 16 digits for 128 bits key size like CryptoJS.enc.Utf8.parse('8080808080808080')
        Length of secret key should be 24 digits for 192 bits key size like CryptoJS.enc.Utf8.parse('808080808080808012345678')
        Length of secret key should be 32 digits for 256 bits key size like  CryptoJS.enc.Utf8.parse('12345678901234567890123456789012');
        keySize: 128 / 8
        keySize: 256 / 32
        keySize: 192 / 24
        */
        const key2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encryp_Key);
        const iv2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encrypt_Iv);
       
        encryptedString = CryptoJS.AES.encrypt(cipherText, key2, {
            iv: iv2,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            keySize: 256 / 32
        });
    }

    return encryptedString.toString();
}
function decpwd(cipherText) {
    let decryptedString = ''

    if (cipherText !== '') {
        const key2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encryp_Key);
        const iv2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encrypt_Iv);
        const dec = CryptoJS.AES.decrypt(cipherText, key2, {
            iv: iv2,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            keySize: 256 / 32
        });
        decryptedString = dec.toString(CryptoJS.enc.Utf8);
    }
    return decryptedString;
}

    function EncryptText(text)
    {
        let key1 = sessionStorage.getItem("cap-token");
        key1 = key1.replace(/\-/g,"");
        var text = CryptoJS.enc.Utf8.parse(text);
        var key = CryptoJS.enc.Utf8.parse(key1); //secret key
        
        var IV = CryptoJS.enc.Utf8.parse(key1.substring(0, 16)); //16 digit
        var encryptedString = CryptoJS.AES.encrypt(text, key, {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            keySize: 256 / 32
        });

        return encryptedString.toString();
    }

function DecryptText(text) {
    let key1 = sessionStorage.getItem("cap-token");
    let decryptedString = ''

    if (text !== '') {
        // const key2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encryp_Key);
        // const iv2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_encrypt_Iv);

        let key1 = sessionStorage.getItem("cap-token");
        key1 = key1.replace(/\-/g, "");
        var key = CryptoJS.enc.Utf8.parse(key1); //secret key
        var IV = CryptoJS.enc.Utf8.parse(key1.substring(0, 16)); //16 digit

        const dec = CryptoJS.AES.decrypt(text, key, {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            keySize: 256 / 32
        });
        decryptedString = dec.toString(CryptoJS.enc.Utf8);
    }
    return decryptedString;
}
//added for ABDM
// utils/rsaEncrypt.js

 // Your public key (Base64, without headers)
// const publicKeyBase64 = `
// MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAstWB95C5pHLXiYW59qyO4Xb+
// 59KYVm9Hywbo77qETZVAyc6VIsxU+UWhd/k/YtjZibCznB+HaXWX9TVTFs9Nwgv7LRGq
// 5uLczpZQDrU7dnGkl/urRA8p0Jv/f8T0MZdFWQgks91uFffeBmJOb58u68ZRxSYGMPe4h
// b9XXKDVsgoSJaRNYviH7RgAI2QhTCwLEiMqIaUX3p1SAc178ZlN8qHXSSGXvhDR1GKM+y
// 2DIyJqlzfik7lD14mDY/I4lcbftib8cv7llkybtjX1AayfZp4XpmIXKWv8nRM488/jOAF
// 81Bi13paKgpjQUUuwq9tb5Qd/DChytYgBTBTJFe7irDFCmTIcqPr8+IMB7tXA3YXPp3z6
// 05Z6cGoYxezUm2Nz2o6oUmarDUntDhq/PnkNergmSeSvS8gD9DHBuJkJWZweG3xOPXiK
// QAUBr92mdFhJGm6fitO5jsBxgpmulxpG0oKDy9lAOLWSqK92JMcbMNHn4wRikdI9HSiX
// rrI7fLhJYTbyU3I4v5ESdEsayHXuiwO/1C8y56egzKSw44GAtEpbAkTNEEfK5H5R0QnV
// BIXOvfeF4tzGvmkfOO6nNXU3o/WAdOyV3xSQ9dqLY5MEL4sJCGY1iJBIAQ452s8v0ynJG
// 5Yq+8hNhsCVnklCzAlsIzQpnSVDUVEzv17grVAw078CAwEAAQ==
// `.replace(/\s+/g, "");

// ABDM public key - populated dynamically from AbhaCert configuration
let publicKeyBase64 = "";

function setAbhaPublicKey(publicKey) {
    publicKeyBase64 = publicKey?.replace(/\s+/g, "") || "";
}

// Convert Base64 to ArrayBuffer
function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

// Convert ArrayBuffer to Base64
function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  return window.btoa(binary);
}

// async function encryptOtp(otp) {
//   const publicKeyBuffer = base64ToArrayBuffer(publicKeyBase64);
async function encryptOtp(otp) {
  if (!publicKeyBase64) {
    throw new Error("ABDM public key is not configured");
  }
  const publicKeyBuffer = base64ToArrayBuffer(publicKeyBase64);

  // Import RSA public key
  const publicKey = await window.crypto.subtle.importKey(
    "spki",
    publicKeyBuffer,
    {
      name: "RSA-OAEP",
      hash: "SHA-1", // IMPORTANT for ABDM
    },
    false,
    ["encrypt"]
  );

  // Encrypt OTP
  const encryptedDataAbdm = await window.crypto.subtle.encrypt(
    {
      name: "RSA-OAEP",
    },
    publicKey,
    new TextEncoder().encode(otp)
  );

  return arrayBufferToBase64(encryptedDataAbdm);
}
//end added for ABDM